import type { FaireProductEntity } from "../../entity_types/product";

export const p_p5sva8j7zs: FaireProductEntity = {
  token: "p_p5sva8j7zs",
  type: "product",
  name: "Red Aventurine Mini Half Moon | Red Aventurine Crystal",
  brandToken: "b_en1yij2pf6",
  brandName: "Natures Artifacts Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/24a340c761e85de7b327cb75e65c077aced79190a40aae14cdff820e9d49ab3a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c60ec635fa262c7982ac63bdd2f909ba9e19e8e7018f7a2d0e8f96f598be9270.jpeg",
    "https://cdn.faire.com/fastly/f41768378c0c566d51607e773390f6c9aca25e034cf2a4b9a83bcc7cb9eaeb6f.jpeg",
    "https://cdn.faire.com/fastly/de287e37cc5afb3efb0a35b8c0bf7fdc05228974fb89b2b08a3ef77932717ed7.jpeg",
    "https://cdn.faire.com/fastly/48db18810e47271cc83602f6413279acbe672e653a7bbbb629b6451b1e5a17c6.jpeg",
    "https://cdn.faire.com/fastly/e952854c2e5c133f7cb3feca313dd962509261ae064ed974e6953eccf0ce8740.jpeg",
    "https://cdn.faire.com/fastly/c93517f19c1eb353eb9d58688b9824877c27fd4ca45019432c9fac223ba72914.jpeg",
    "https://cdn.faire.com/fastly/6c927feac1b35cd96ccc2a2d2da3007fa0342318b00d84ec227f2ccfc626dbd8.jpeg",
    "https://cdn.faire.com/fastly/8df78a5df1baf90007f7d11681a568fd0cff53bafffb4e5f64f83668177dfdbb.jpeg",
    "https://cdn.faire.com/fastly/b216a40d0d22972e9031065308cb3da580f696fe4e0aef7da4e6d8a95b8a8fd0.jpeg",
    "https://cdn.faire.com/fastly/1d3b749ae158e607ffb5048e0194e9b2e0f06bd11f92da479806b2a464dda91a.jpeg",
    "https://cdn.faire.com/fastly/7896d23eb6180bd858d0d8900e6facdccb556dd853a5ee7ce63f1fb97b75d2a9.jpeg",
  ],
  priceDollars: 2.77,
  description:
    "Red Aventurine gemstone amplifies energy.  It brings on self-confidence and willpower built on fearlessness. It inspires creativity, passion, and determination. It helps to heal and dispel negative thoughts and beliefs that create feelings of being disconnected.  In the shape of a mini half-moon, Red Aventurine makes an appealing décor item. It can be used in small crystal grids. It can be held during Meditation to revitalize and renew. Easy to carry around in pocket or bag as it raises enthusiasm and encourages one to take on challenges. The ideal piece for Crystal Collectors. Buy our supreme quality Red Aventurine Mini Half Moon to offer your customers a beautiful variety of healing crystals.",
  tags: [],
  msrpDollars: 9.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:26.037Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
